import React, { useState } from 'react';
import Cookies from 'js-cookie';
import useLocale from '@/hooks/useLocale';
import useSupergatorSso from '@/hooks/useSupergatorSso';
import { supergatorAnalytics } from '@/analytics/supergator';
import * as Styles from './AgentsBanner.styles';
import {
  Button,
  IconButton,
  IconClose,
  IconStars01,
  IconSuperGator,
} from 'gatorcomponents';

const COOKIE_NAME = 'agents-banner-closed';

const AgentsBanner = () => {
  const [closed, setClosed] = useState(() => Cookies.get(COOKIE_NAME) === 'true');
  const { sites: locale } = useLocale();
  const { redirectToSupergator } = useSupergatorSso();

  if (closed) {
    return null;
  }

  const handleCtaClick = () => {
    supergatorAnalytics.agentsBannerCtaClick();
    redirectToSupergator();
  };

  const handleClose = () => {
    Cookies.set(COOKIE_NAME, 'true', { expires: 30 });
    setClosed(true);
  };

  return (
    <Styles.Wrapper>
      <Styles.LogoPlaceholder>
        <IconSuperGator />
      </Styles.LogoPlaceholder>
      <Styles.Separator />
      <Styles.Tagline>
        {locale.agentsBanner.tagline}
        <Styles.TaglineIcon>
          <IconStars01 />
        </Styles.TaglineIcon>
      </Styles.Tagline>
      <Styles.Actions>
        <Button onClick={handleCtaClick} variant="secondary" data-testid="agents-banner-cta-mobile" label={locale.agentsBanner.cta} />
      </Styles.Actions>
      <Styles.CloseAdapter>
        <IconButton onClick={handleClose} variant="clear" data-testid="agents-banner-close-mobile">
          <IconClose />
        </IconButton>
      </Styles.CloseAdapter>
    </Styles.Wrapper>
  );
};

export default AgentsBanner;
